import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { formatAMPM } from "../../../utils/common";
import { OrderListUpdate } from "../../../API/routine";
import { toast } from "react-toastify";

const EventLogisticsList = ({
  logisticsDetails,
  handleLogisticsChange,
  eventId,
  fetchRoutineDetail,
  showEventType,
}) => {
  const [rows, setRows] = useState([]);
  const [activeRowId, setActiveRowId] = useState(null);
  const IsAccess = JSON.parse(localStorage.getItem("userDetail"));

  useEffect(() => {
    setRows(logisticsDetails);
  }, [logisticsDetails, showEventType]);

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const { source, destination } = result;

    const updatedRows = [...rows];
    const [removed] = updatedRows.splice(source.index, 1);
    updatedRows.splice(destination.index, 0, removed);

    const updatedArray = updatedRows.map((row, i) => ({
      id: row.id,
      index: i,
    }));

    onChange(updatedArray, rows[source.index]?.id, rows[destination.index]?.id);
    setRows(updatedRows);
  };

  const onChange = async (data, previousID, newID) => {
    const payload = {
      event_id: eventId,
      previous_id: previousID,
      new_id: newID,
      order_list_update: data,
    };
    try {
      const response = await OrderListUpdate(payload);
      if (response?.status) {
        fetchRoutineDetail();
        toast.success(response.message || "Success!");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error during API request:", error);
    }
  };

  const handleAccessChange = async (userId, changes) => {
    const payload = {
      id: userId,
      completed:
        changes?.props !== undefined
          ? 0
          : changes?.completed !== ""
          ? changes?.completed === true
            ? 1
            : 0
          : 0,
    };

    if (typeof changes?.starts !== "undefined") {
      payload.starts = changes.starts;
    }
    if (changes?.props !== undefined) {
      payload.props = changes.props;
    }
    if (changes.previousId) {
      payload.previous_id = changes.previousId;
    }

    await handleLogisticsChange(payload);

    if (changes.starts === 1) {
      setActiveRowId(userId);
    }
    if (changes.starts === 2 || changes.completed === true) {
      setActiveRowId(null);
    }
  };

  return (
    <div className="container-fluid drag-table">
      <div className="row">
        <div
          className="col-12 table-responsive"
          style={{ maxHeight: "350px", overflowY: "auto" }}
        >
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="droppable">
              {(provided) => (
                <table
                  className="table"
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  style={{ width: "100%" }}
                >
                  <thead className="text-center">
                    <tr>
                      <th>Time</th>
                      <th>Entry</th>
                      <th>Entry Title</th>
                      <th>Age</th>
                      <th>Level</th>
                      <th>Entry Division</th>
                      <th>Performers</th>
                      <th>Category</th>
                      <th>Starts</th>
                      <th>Props</th>
                      <th>Completed</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) => {
                      if (row?.completed !== showEventType) return null;

                      return (
                        <Draggable
                          key={row.id}
                          draggableId={row.id.toString()}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <tr
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              className={`text-center ${
                                row?.starts === 1 ||
                                row?.starts === 2 ||
                                row?.completed === 1
                                  ? "start"
                                  : "notstart"
                              }`}
                              style={{
                                cursor:
                                  row.completed === 1 ? "not-allowed" : "",
                                ...provided.draggableProps.style,
                                // position: snapshot.isDragging ? "absolute" : "static",
                                zIndex: snapshot.isDragging ? 999 : "auto",
                                width: "100%",
                                // left: snapshot.isDragging ? "0" : "auto",
                                transition: "all 0.1s ease-out",
                              }}
                            >
                              <td>{formatAMPM(row?.event_time_from)}</td>
                              <td>{row?.entry || "-"}</td>
                              <td>{row?.entry_title || "-"}</td>
                              <td>{row?.masterAgeClass?.name || "-"}</td>
                              <td>{row?.masterLevel?.name || "-"}</td>
                              <td>{row?.masterEntryDivision?.name || "-"}</td>
                              <td>{row?.performers || "-"}</td>
                              <td>{row?.masterMusicCategory?.name || "-"}</td>
                              <td className="text-center">
                                {row?.type === "routine" &&
                                IsAccess?.is_access ? (
                                  <div className="checkbox-wrapper">
                                    <label
                                      htmlFor={`on-${row.id}`}
                                      className="checkbox-label check_box_btn"
                                    >
                                      <input
                                        type="checkbox"
                                        id={`on-${row.id}`}
                                        checked={row.starts === 1}
                                        disabled={row.completed === 1}
                                        onChange={async () => {
                                          if (row.starts === 1) {
                                            await handleAccessChange(row.id, {
                                              starts: 0,
                                              completed: false,
                                            });
                                            setActiveRowId(null);
                                          } else {
                                            await handleAccessChange(row.id, {
                                              starts: 1,
                                              completed: false,
                                              previousId: activeRowId,
                                            });
                                            setActiveRowId(row.id);
                                          }
                                        }}
                                      />
                                      <p className="simple">On</p>
                                    </label>
                                    <label
                                      htmlFor={`off-${row.id}`}
                                      className="checkbox-label check_box_btn"
                                    >
                                      <input
                                        type="checkbox"
                                        id={`off-${row.id}`}
                                        checked={row.starts === 2}
                                        disabled={row.completed === 1}
                                        onChange={async () => {
                                          if (row.starts === 2) {
                                            await handleAccessChange(row.id, {
                                              starts: 0,
                                              completed: false,
                                            });
                                            setActiveRowId(null);
                                          } else {
                                            await handleAccessChange(row.id, {
                                              starts: 2,
                                              completed: false,
                                            });
                                            setActiveRowId(null);
                                          }
                                        }}
                                      />
                                      <p>Off</p>
                                    </label>
                                  </div>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td className="text-center">
                                {row?.type === "routine" &&
                                IsAccess?.is_access ? (
                                  <label className="container">
                                    <input
                                      type="checkbox"
                                      checked={row?.props === 1}
                                      disabled={row?.completed === 1}
                                      onChange={(e) => {
                                        const newValue = e.target.checked
                                          ? 1
                                          : 0;
                                        handleAccessChange(row.id, {
                                          props: newValue,
                                          starts: row.starts ?? 0,
                                        });
                                      }}
                                    />
                                    <span className="checkmark"></span>
                                  </label>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td className="text-center">
                                {IsAccess?.is_access ? (
                                  <input
                                    type="checkbox"
                                    className="complete"
                                    onChange={(e) =>
                                      row.completed === 0
                                        ? handleAccessChange(row.id, {
                                            completed: e.target.checked,
                                            starts: row.starts ?? 0,
                                          })
                                        : null
                                    }
                                    checked={row.completed === 1}
                                  />
                                ) : (
                                  "-"
                                )}
                              </td>
                            </tr>
                          )}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                  </tbody>
                </table>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </div>
    </div>
  );
};

export default EventLogisticsList;
